export default {
  computed: {
    steps() {
      const steps = [];

      steps.push({ name: 'substore.progress_selection' });
      steps.push({ name: 'substore.progress_summary' });
      steps.push({ name: 'substore.progress_confirmation' });
      return steps;
    },
  },
};
